export const APPLICANT_COMPLIANCE_THRESHOLDS = {
  // Explicit percentage ranges used for applicant compliance card bucketing.
  qualifiedStartPercent: 80,
  qualifiedEndPercent: 100,
  partiallyQualifiedStartPercent: 50,
  partiallyQualifiedEndPercent: 79.99,
  unqualifiedStartPercent: 0,
  unqualifiedEndPercent: 49.99,
};

export const APPLICANT_COMPLIANCE_SCORE_KEYS = [
  "compliance_score",
  "compliance_percentage",
  "overall_compliance_percentage",
  "onboarding_compliance_percentage",
  "compliance_percent",
];
